<template>
  <News code="gang" leftTitle="推荐信息" />
</template>
<script>
import News from "./news.vue";

export default {
  name: "About",
  components: {
    News,
  },
  data() {
    return {
      pageData: {},
    };
  },
  created() {},
  methods: {},
};
</script>
